import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/$slug/admin/ai-models")({
  staticData: { title: "AI models" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/admin/ai-models/page.tsx"),
    "AiModelsPage",
  ),
})
